import React, { useEffect, useState } from "react";
import { useHistory, Link } from "react-router-dom";
import moment from "moment";
import Sidebar from "../../../../partials/aside/Sidebar";
import helpersNumbers from "../../../../../helpers/numbers";
import helperSpinner from "../../../../../helpers/spinner";
import httpService from "../../../../../services/httpServices/httpServices";
import helpersTime from "../../../../../helpers/time";
import { useParams } from "react-router-dom/cjs/react-router-dom.min";

export default function View() {
  const params = useParams();
  const giftID = params.giftChargeUserID;

  const history = useHistory();
  const [gift, setGift] = useState();

  useEffect(() => {
    getGift();
  }, []);

  const getGift = async () => {
    helperSpinner.showSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    const resultSendRequestGetGift = await sendRequestGetGift();
    helperSpinner.removeSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    if (!resultSendRequestGetGift) {
      return;
    }

    setGift(resultSendRequestGetGift);
  };

  const getHeaderForRequest = () => {
    const token = localStorage.getItem("token");
    const headersRequest = {
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    };

    return headersRequest;
  };

  const sendRequestGetGift = async () => {
    let headersRequest = getHeaderForRequest();
    let gift;
    try {
      gift = await httpService.getRequest(
        `${process.env.REACT_APP_DOMAIN_API}/v1/manage/gift-charge/${giftID}`,
        headersRequest
      );
    } catch (error) {
      alert(error.response.data.message);
      return false;
    }
    return gift.data.data;
  };

  const generateRangeCharge = () => {
    return (
      <div className="pt-2">
        <div className="table-responsive">
          <table className="table table-hilite tbl-td-white-space">
            <thead>
              <tr>
                <td>حداکثر مبلغ</td>
                <td>حداقل مبلغ</td>
                <td>درصد</td>
              </tr>
            </thead>
            <tbody>
              {gift.conditions.range_charge.map((item) => {
                return (
                  <tr>
                    <td className="number-finance">
                      {helpersNumbers.toPersianNum(
                        helpersNumbers.toFormatFinanceNumber(item.min)
                      )}
                    </td>
                    <td className="number-finance">
                      {helpersNumbers.toPersianNum(
                        helpersNumbers.toFormatFinanceNumber(item.max)
                      )}
                    </td>
                    <td className="number-finance">
                      {helpersNumbers.toPersianNum(
                        helpersNumbers.toFormatFinanceNumber(item.percent)
                      )}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      </div>
    );
  };

  const generateDoNotHaveRangeCharge = () => {
    return (
      <div className="pt-2">
        <div className="alert alert-info">شما هیچ بازه مبلغی ندارید.</div>
      </div>
    );
  };

  const generateListUserUseGift = () => {
    return (
      <div>
        <span className="pr-2">
          <Link
            target="_blank"
            to="/finance/manage/invoices"
            className="btn btn-info"
          >
            لیست پرداخت
          </Link>
        </span>
        <div className="pt-2">
          <div className="table-responsive">
            <table className="table table-hilite tbl-td-white-space">
              <thead>
                <tr>
                  <td>شماره </td>
                  <td>شماره کاربر</td>
                  <td>شماره پرداخت</td>
                </tr>
              </thead>
              <tbody>
                {gift.users_use_gift.map((item, index) => {
                  return (
                    <tr>
                      <td>{index + 1}</td>
                      <td>
                        {item.userID}
                        <span className="pr-2">
                          <Link
                            target="_blank"
                            className="btn btn-info"
                            to={`/user/show-info-user/${item.userID}`}
                          >
                            اطلاعات کاربر
                          </Link>
                        </span>
                      </td>
                      <td>{item.paymentID}</td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    );
  };

  const generateNoUserUseThisGift = () => {
    return (
      <div className="pt-2">
        <div className="alert alert-info">
          هیچ کاربری از این هدیه استفاده نکرده است.
        </div>
      </div>
    );
  };

  const generateGift = () => {
    return (
      <>
        <div className="pt-2">
          <div className="table-responsive">
            <table className="table table-hilite tbl-td-white-space">
              <thead>
                <tr>
                  <td
                    colSpan={2}
                    className="text-center"
                    style={{ borderRadius: "25px 25px 0 0" }}
                  >
                    <b>اطلاعات هدیه افزایش اعتبار کاربران</b>
                  </td>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>توضیحات</td>
                  <td>{gift.description}</td>
                </tr>
                <tr>
                  <td>درصد</td>
                  <td>{helpersNumbers.toPersianNum(gift.amount)}</td>
                </tr>
                <tr>
                  <td>تاریخ شروع</td>
                  <td dir="ltr">
                    <span>
                      {helpersNumbers.toPersianNum(
                        helpersTime.convertGregorianToJalali(
                          gift.start_date.split(" ")[0]
                        ) +
                          " " +
                          gift.start_date.split(" ")[1]
                      )}
                    </span>
                  </td>
                </tr>
                <tr>
                  <td>تاریخ پایان</td>
                  <td dir="ltr">
                    {helpersNumbers.toPersianNum(
                      helpersTime.convertGregorianToJalali(
                        gift.end_date.split(" ")[0]
                      ) +
                        " " +
                        gift.end_date.split(" ")[1]
                    )}
                  </td>
                </tr>
                <tr>
                  <td>تعداد استفاده کاربران از هدیه</td>
                  <td>{helpersNumbers.toPersianNum(gift.count_use)}</td>
                </tr>
                <tr>
                  <td>شرط محدودیت بیشترین استفاده هدیه افزایش اعتبار</td>
                  <td>
                    {gift.conditions.max_count_use_gift == "0" ? (
                      <span className="badge badge-danger">غیرفعال</span>
                    ) : (
                      helpersNumbers.toPersianNum(
                        gift.conditions.max_count_use_gift
                      )
                    )}
                  </td>
                </tr>
                <tr>
                  <td>
                    شرط محدودیت بیشترین استفاده هدیه افزایش اعتبار هر کاربر
                  </td>
                  <td>
                    {gift.conditions.max_count_use_each_user == "0" ? (
                      <span className="badge badge-danger">غیرفعال</span>
                    ) : (
                      helpersNumbers.toPersianNum(
                        gift.conditions.max_count_use_each_user
                      )
                    )}
                  </td>
                </tr>
                <tr>
                  <td>فعال</td>
                  <td>
                    {
                      <span
                        className={`badge  badge-${
                          gift.active ? "success" : "danger"
                        } `}
                      >
                        {gift.active ? "فعال" : "غیرفعال"}
                      </span>
                    }
                  </td>
                </tr>
                <tr>
                  <td>تاریخ درج</td>
                  <td dir="ltr">
                    {helpersNumbers.toPersianNum(
                      helpersTime.convertGregorianToJalali(gift.created_at) +
                        " " +
                        moment(gift.created_at).local().format("HH:mm:ss")
                    )}
                  </td>
                </tr>
                <tr>
                  <td>تاریخ ویرایش</td>
                  <td dir="ltr">
                    {helpersNumbers.toPersianNum(
                      helpersTime.convertGregorianToJalali(gift.updated_at) +
                        " " +
                        moment(gift.updated_at).local().format("HH:mm:ss")
                    )}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        {gift.conditions.range_charge.length > 0
          ? generateRangeCharge()
          : generateDoNotHaveRangeCharge()}

        {gift.users_use_gift.length > 0
          ? generateListUserUseGift()
          : generateNoUserUseThisGift()}
      </>
    );
  };

  return (
    <>
      <Sidebar />

      <div className="content-wrapper">
        <section className="content-header pt-4  pb-0">
          <div className="container-fluid">
            <div className="row">
              <div className="w-100 text-center">
                <h1 className="px-5 py-1  bg-warning">
                  نمایش اطلاعات هدیه افزایش اعتبار
                </h1>
              </div>
            </div>
          </div>
        </section>
        <section className="content">
          <div className="card">
            <div className="card-body">
              <div className="text-left pb-2">
                <Link
                  className="btn btn-primary"
                  to="/finance/manage/gift-charge-user/all"
                >
                  <span>بازگشت</span>
                  <span className="pr-2">
                    <i className="fas fa-arrow-left"></i>
                  </span>
                </Link>
              </div>
              {gift && generateGift()}
            </div>
          </div>
        </section>
      </div>
    </>
  );
}
